<template>
    <div>
        <link v-for="(css, key) in styles.slice().reverse()" v-bind:key="key" rel="stylesheet" :href="css"/>
    </div>    
</template>

<script>
    import { setTeatroScope } from '@/utils/teatroScope';

    export default {
        name: 'App',
        props: ['estilos'],
        data() {
            return {
                styles: [
                    '/css/teatros.css',
                    '/css/main2.css',
                    '/css/bootstrap-grid.min.css',
                    '/css/bootstrap-texts.min.css',
                    '/css/hamburgers.css'
                ]
            }
        },
        created() {
            // Este componente solo se pinta cuando la app ya tiene la configuración del
            // sitio (ver AppLoader), y la acción CONFIG dejó el teatro en localStorage
            // antes de guardarlo en el store. Se publica en <html data-teatro> para que
            // main2.css pueda acotar una regla a un cliente concreto (ver
            // src/utils/teatroScope.js y tests/unit/components/css/LoadCssComponent.spec.js).
            setTeatroScope(localStorage.getItem('hash_teatro'));
        },
    }
</script>
